import { oc } from '@orpc/contract';
import { quickRangeInputSchema, quickRangeSchema } from '../schemas/estimates.schemas.js';
/** Computes the four condition × mileage benchmarks (plan §5.11). Nothing is written. */
export const getEstimateQuickRangeContract = oc
    .route({
    method: 'GET',
    path: '/estimates/{estimateId}/quick-range',
    tags: ['Estimates'],
    summary: 'Compute the quick price range',
})
    .input(quickRangeInputSchema)
    .output(quickRangeSchema);
//# sourceMappingURL=get-estimate-quick-range.contract.js.map